import {
  Dropdown,
  type DropdownOption,
} from "@freightsimple/ui-core/Controls/Dropdown";
import {
  FormItem,
  type ErrorMessageType,
} from "@freightsimple/ui-core/FormLayout/FormItem";
import { Grid } from "@freightsimple/ui-core/PageLayout/Grid";
import { ShowFormErrors } from "@freightsimple/ui-core/FormLayout/ShowFormErrors";
import { useState } from "react";
import { defaultHoursOptions } from "../Helpers/locationsHoursOptions";

interface LocationsDockHoursInputProps {
  openFrom: string;
  openUntil: string;
  setOpenFrom: (_: string) => void;
  setOpenUntil: (_: string) => void;
  openFromOptions?: DropdownOption[] | undefined;
  openUntilOptions?: DropdownOption[] | undefined;
  errorMessage: ErrorMessageType;
  warningMessage?: ErrorMessageType | undefined;
  forceValidation: boolean;
}

/**
 * The open-from / open-until hours pair. The two dropdowns share one
 * error/warning message — carried by the first field so the pair doesn't
 * stack two reserved message slots — because the validation (e.g. "must be
 * open at least 2 hours") is about the pair, not either field alone.
 */
function LocationsDockHoursInput(props: LocationsDockHoursInputProps) {
  const [validated, setValidated] = useState(false);

  const openFromOptions = props.openFromOptions ?? defaultHoursOptions;
  const openUntilOptions = props.openUntilOptions ?? defaultHoursOptions;

  function setOpenFrom(hours: string) {
    setValidated(true);
    props.setOpenFrom(hours);
  }

  function setOpenUntil(hours: string) {
    setValidated(true);
    props.setOpenUntil(hours);
  }

  return (
    <ShowFormErrors show={validated || props.forceValidation}>
      <Grid columns={2} gap="sm">
        <FormItem
          label="Open From"
          error={props.errorMessage}
          warning={props.warningMessage}
          fillWidth
        >
          <Dropdown
            value={props.openFrom}
            onChange={setOpenFrom}
            options={openFromOptions}
            data-testid="dock-hours-open-from"
          />
        </FormItem>
        <FormItem label="Open Until" fillWidth>
          <Dropdown
            value={props.openUntil}
            onChange={setOpenUntil}
            options={openUntilOptions}
            data-testid="dock-hours-open-until"
          />
        </FormItem>
      </Grid>
    </ShowFormErrors>
  );
}
export default LocationsDockHoursInput;
